import { withInstall } from '@park-ui/utils'
import Row from './src/row.vue'

export const ElRow = withInstall(Row)
export default ElRow

export * from './src/row'
